import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import Modal from '@hellodarwin/core/lib/components/common/hd-modal';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import FormItem from '@hellodarwin/core/lib/components/common/form-item';
import Form from 'antd/es/form';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { FeedbackActions, FeedbackIntro, FeedbackTrailingActions, } from './styles';
export const MessageFeedbackModal = ({ open, onClose, onSubmit, messageId: _messageId, isSubmitting = false, rating, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [comment, setComment] = useState('');
    const [form] = Form.useForm();
    const handleSubmitWithComment = () => {
        if (comment.trim()) {
            onSubmit(comment.trim());
        }
        else {
            handleClose();
        }
    };
    const handleClose = () => {
        setComment('');
        form.resetFields();
        onClose();
    };
    const handleSkipComment = () => {
        handleClose();
    };
    return (_jsxs(Modal, { open: open, handleCancel: handleClose, children: [_jsxs(FeedbackIntro, { children: [_jsx(Typography, { textAlign: "center", elementTheme: "h4", children: t('assistant|feedback_thank_you', 'Thank you for your feedback!') }), _jsx(Typography, { textAlign: "center", elementTheme: "body1", children: rating === 'positive'
                            ? t('assistant|positive_feedback_prompt', 'Thank you! Would you like to tell us what was helpful?')
                            : t('assistant|negative_feedback_prompt', 'Thank you for the feedback. What could we improve?') })] }), _jsx(Form, { form: form, layout: "vertical", children: _jsx(FormItem, { name: "comment", children: _jsx(TextArea, { rows: 4, placeholder: t('assistant|feedback_placeholder', 'Share your thoughts...'), value: comment, onChange: (e) => setComment(e.target.value), disabled: isSubmitting }) }) }), _jsxs(FeedbackActions, { children: [_jsx("div", {}), _jsx(Button, { size: "small", defaultStyle: theme.colors.blue_1, onClick: handleSubmitWithComment, disabled: isSubmitting || !comment.trim(), loading: isSubmitting, children: t('button.submit', 'Submit') }), _jsx(FeedbackTrailingActions, { children: _jsx(Button, { size: "small", isLink: true, defaultStyle: theme.colors.grey_2, onClick: handleSkipComment, disabled: isSubmitting, children: t('assistant|skip', 'Skip') }) })] })] }));
};
export default MessageFeedbackModal;
